import React, { useState } from "react";
import CustomDialog from "components/CustomDialog";
import CustomTextField from "components/Input/CustomTextField";
import { useDispatch, useSelector } from "react-redux";
import useQuery from "hooks/useQuery";
import { commentStatusEnum } from "constants/globalEnum";
import { CREATE_COMMENT } from "store/key";

const AddComment = () => {
    const formId = useQuery('id');
    const [comment, setComment] = useState("");
    const { isShow: isAddModeShow, label, questionNo, questionField } = useSelector(state => state.comment.addBox);
    const { currentTabId } = useSelector(state => state.comment);
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const applicationDetail = useSelector((state) => state.applicationDetail[formId ?? 'undefined']);
    const { siteInfo } = applicationDetail;


    const onCancel = () => {
        setComment("");
        dispatch({
            type: 'SET_COMMENT',
            payload: {
                addBox: {
                    Label: "",
                    isShow: false,
                }
            }
        });
    }

    const onConfirm = () => {
        if (!comment?.trim()) return;
        const commentContent = [{
            text: comment,
            lastUpdated: Date.now(),
            status: commentStatusEnum.DRAFT,
            updatedBy: `${user?.detail?.firstName} ${user?.detail?.surname}`,
        }];
        const params = {
            "appId": formId,
            "subNo": "",
            "studyInfo": currentTabId === -1 ? "Y" : "N",
            "siteInfo": siteInfo?.find(item => item?.id === currentTabId)?.['institution'] || "",
            "appNo": formId,
            "questionNo": questionField,
            "questionDesc": label,
            "commentStatus": "Draft",
            "commentContext": JSON.stringify(commentContent)
        }
        
        dispatch({
            type: CREATE_COMMENT,
            payload: {
                params,
                callback: onCancel
            }
        });
    }

    return (
        <div>
            <CustomDialog
                isShow={isAddModeShow}
                title="Add Comment"
                confirmText="Save"
                onCancel={onCancel}
                onConfirm={onConfirm}
            >
                <div style={{ marginBottom: 10 }}>{label}</div>
                <CustomTextField
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Enter your comment here"
                    isTextArea
                />
            </CustomDialog>
        </div>
    );
};

export default AddComment;
